import { Moment } from 'moment';

export const isRangeOverlap = (startRange: Moment[], endRange: Moment[]) =>
  (startRange[0].isBetween(endRange[0], endRange[1], null, '[]') ||
    startRange[1].isBetween(endRange[0], endRange[1], null, '[]')) &&
  !startRange[1].isSame(endRange[0]) &&
  !startRange[0].isSame(endRange[1]);
